<template>
  <div
    @click="$emit('select', value)"
    class="cursor-pointer pb-1 transition-colors font-semibold"
    :class="[active ? 'text-brand-blue border-b-2 border-brand-blue' : 'text-brand-brown']"
  >
    {{ label }}
  </div>
</template>

<script>
export default {
  name: 'NavTab',
  props: {
    active: Boolean,
    label: String,
    value: String,
  },
};
</script>
